// extracted by mini-css-extract-plugin
export default {"FaUser":"nots_FaUser__i4kLd"};